var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#26C93C",
    d: "M80.182 13.3a2.486 2.486 0 0 1-.563.493c-.27.175-.556.32-.856.434a6.52 6.52 0 0 1-2.404.442c-.817.01-1.63-.12-2.403-.387a5.212 5.212 0 0 1-1.842-1.11 4.997 4.997 0 0 1-1.186-1.764 6.214 6.214 0 0 1-.423-2.36 5.928 5.928 0 0 1 .416-2.253 5.098 5.098 0 0 1 1.183-1.774 5.38 5.38 0 0 1 1.857-1.156 6.78 6.78 0 0 1 2.427-.412 6.654 6.654 0 0 1 2.189.319 5.7 5.7 0 0 1 1.386.66v2.701a4.509 4.509 0 0 0-.612-.698 4.385 4.385 0 0 0-.816-.606 4.557 4.557 0 0 0-1.001-.426 3.999 3.999 0 0 0-1.148-.163 4.292 4.292 0 0 0-1.591.278c-.45.172-.86.437-1.202.778a3.31 3.31 0 0 0-.755 1.203c-.18.5-.269 1.028-.262 1.56a4.507 4.507 0 0 0 .245 1.48 3.274 3.274 0 0 0 1.887 2.02c.52.21 1.074.319 1.634.319.438.004.875-.049 1.3-.156a4.758 4.758 0 0 0 1.078-.42c.312-.165.6-.372.857-.616a3.26 3.26 0 0 0 .6-.776l.005 2.39ZM90.245 5.418h-3.636v9.085h-1.926V5.418H81.11V3.632h9.136v1.786ZM93.862 11.117v3.386h-1.924V3.633h3.588c1.705 0 2.94.307 3.706.923.766.616 1.148 1.535 1.147 2.757 0 1.273-.41 2.225-1.233 2.857-.821.632-2.028.947-3.62.947h-1.664Zm0-5.7v3.914h1.802c.904 0 1.581-.158 2.033-.474.452-.316.678-.846.678-1.591 0-.672-.21-1.149-.631-1.429-.421-.28-1.104-.42-2.049-.42h-1.833ZM111.529 14.503h-2.05l-1.032-2.579h-4.944l-1.017 2.579h-1.959l4.381-10.87h2.187l4.434 10.87Zm-3.794-4.364-1.771-4.457-1.769 4.457h3.54ZM115.979 8.974l-3.651-5.342h2.31l2.758 4.115 2.931-4.115h2.234l-3.852 5.234 3.99 5.637h-2.298l-3.06-4.38-2.958 4.38h-2.256l3.852-5.529ZM123.087 9.044a6.041 6.041 0 0 1 .407-2.253 5.152 5.152 0 0 1 1.164-1.77 5.26 5.26 0 0 1 1.818-1.157 6.55 6.55 0 0 1 2.388-.412c.803-.01 1.603.12 2.362.386a5.14 5.14 0 0 1 1.826 1.11 4.914 4.914 0 0 1 1.17 1.764c.288.752.43 1.554.416 2.36a6.035 6.035 0 0 1-.407 2.251 5.128 5.128 0 0 1-1.164 1.77 5.24 5.24 0 0 1-1.825 1.158 6.6 6.6 0 0 1-2.381.41 7.033 7.033 0 0 1-2.364-.38 5.05 5.05 0 0 1-1.826-1.102 4.896 4.896 0 0 1-1.17-1.77 6.344 6.344 0 0 1-.414-2.365Zm2.033.014a4.557 4.557 0 0 0 .245 1.492c.15.45.394.863.716 1.21.332.352.733.63 1.178.816a4.463 4.463 0 0 0 3.174.023 3.424 3.424 0 0 0 1.17-.776c.331-.343.586-.754.748-1.204.179-.5.268-1.029.262-1.56a4.604 4.604 0 0 0-.245-1.491 3.345 3.345 0 0 0-.717-1.212 3.467 3.467 0 0 0-1.178-.815 4.062 4.062 0 0 0-1.625-.302 4.134 4.134 0 0 0-1.557.279 3.302 3.302 0 0 0-1.918 1.988 4.534 4.534 0 0 0-.253 1.552ZM136.961 14.729V3.859h4.684c2.423 0 3.635.9 3.635 2.701a2.919 2.919 0 0 1-.384 1.554c-.257.41-.663.726-1.218.946.668.115 1.158.382 1.469.8.311.42.465.986.462 1.7.013.498-.087.992-.292 1.445-.19.397-.48.737-.84.987-.402.27-.852.46-1.325.56a7.884 7.884 0 0 1-1.764.178l-4.427-.001Zm4.406-6.275c.617 0 1.102-.13 1.457-.387a1.28 1.28 0 0 0 .531-1.087 1.174 1.174 0 0 0-.454-.995c-.304-.227-.8-.34-1.487-.341h-2.527v2.81h2.48Zm.14 4.488c.739 0 1.283-.123 1.632-.37.35-.247.524-.632.524-1.156 0-.528-.185-.9-.554-1.119-.37-.218-.894-.326-1.572-.326h-2.65v2.961l2.62.01ZM157.344 14.503h-2.049l-1.033-2.579h-4.945l-1.017 2.579h-1.958l4.374-10.87h2.189l4.439 10.87Zm-3.794-4.364-1.768-4.457-1.772 4.457h3.54ZM166.769 9.797h-5.9v4.706h-1.926V3.633h1.926V8.01h5.9V3.632h1.927v10.87h-1.927V9.798ZM173.502 11.754l5.885-8.122h2.095v10.87h-1.919V6.257l-5.916 8.247h-2.065V3.633h1.927l-.007 8.12ZM191.253 9.797h-4.955v2.92h5.701v1.786h-7.626V3.633h7.456v1.785h-5.531v2.59h4.961l-.006 1.79ZM52.129 5.447l2.434-1.808h-8.149v10.864h8.149v-1.809h-5.824V9.912h4.969V8.104H48.74V5.447h3.389ZM39.856 12.696H37.43V9.684h2.425c1.476 0 2.163.504 2.163 1.505 0 1.024-.728 1.507-2.163 1.507Zm.405-4.82h-2.83V5.451h4.518l2.434-1.808h-9.278v10.864h4.856c2.723 0 4.284-1.244 4.284-3.412 0-2.074-1.415-3.217-3.985-3.217M61.13 9.616h-2.062V5.451h2.062c1.49 0 2.31.74 2.31 2.085s-.82 2.084-2.31 2.084m.049-5.978h-4.437v10.865h2.326v-3.081h2.111c2.832 0 4.591-1.502 4.591-3.899 0-2.397-1.759-3.888-4.591-3.888M31.124 12.141a4.136 4.136 0 0 1-2.007.508c-2.097 0-3.62-1.508-3.62-3.587s1.523-3.586 3.62-3.586a3.53 3.53 0 0 1 2.115.666L32.9 4.908l-.11-.097c-.98-.864-2.275-1.318-3.764-1.318-1.613 0-3.078.548-4.123 1.545-1.045.997-1.631 2.407-1.631 3.964s.576 2.996 1.625 4.029 2.513 1.604 4.115 1.604c1.677 0 3.14-.59 4.133-1.662l-1.505-1.115-.516.283Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#21A038",
    d: "M16.122 3.497a9.03 9.03 0 0 1 1.079 1.79L9.002 11.33 5.576 9.182V6.598l3.426 2.148 7.12-5.249Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__a)",
    d: "M2.08 9c0-.116.002-.231.008-.346L.01 8.552a8.976 8.976 0 0 0 2.625 6.81l1.473-1.471A6.896 6.896 0 0 1 2.079 9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__b)",
    d: "M9 2.079c.117 0 .232.004.346.01L9.45.01a8.975 8.975 0 0 0-6.814 2.625L4.11 4.11A6.896 6.896 0 0 1 9 2.08Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__c)",
    d: "M8.999 15.921c-.116 0-.231 0-.346-.009l-.104 2.076a8.97 8.97 0 0 0 6.81-2.625l-1.47-1.472A6.902 6.902 0 0 1 9 15.921Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__d)",
    d: "m12.902 3.286 1.75-1.29A8.959 8.959 0 0 0 8.998 0v2.079a6.886 6.886 0 0 1 3.904 1.207Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#21A038",
    d: "M17.999 9a9.066 9.066 0 0 0-.141-1.613L15.92 8.815V9a6.903 6.903 0 0 1-2.28 5.13l1.398 1.544A8.977 8.977 0 0 0 17.999 9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__e)",
    d: "M9 15.921a6.908 6.908 0 0 1-5.13-2.28l-1.544 1.397A8.976 8.976 0 0 0 9 18V15.92Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__f)",
    d: "M4.36 3.87 2.962 2.326A8.976 8.976 0 0 0 0 9h2.08a6.904 6.904 0 0 1 2.28-5.13Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__a",
    x1: 3.057,
    x2: 0.785,
    y1: 15.103,
    y2: 8.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C9DA26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__b",
    x1: 3.23,
    x2: 9.081,
    y1: 3.004,
    y2: 0.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0FA7DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0098F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0290EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__c",
    x1: 8.412,
    x2: 15.028,
    y1: 16.745,
    y2: 15.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#86C239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#219F38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__d",
    x1: 8.566,
    x2: 14.222,
    y1: 0.696,
    y2: 2.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0290EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0C89CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__e",
    x1: 2.848,
    x2: 9.005,
    y1: 14.785,
    y2: 17.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EAE616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D8DF1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BAD52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__f",
    x1: 0.775,
    x2: 3.246,
    y1: 9.252,
    y2: 2.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#81C45E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0FA7DF"
  })))));
};
export default SvgLogo;